import queryString from 'query-string'

export default function getStateFromOnFidoRetryRedirectUrl() {
  const url = window.location.href
  const qs = queryString.parse(url.split('?')[1])
  if (url && url.includes('/onfido/redirect')) {
    return qs.state
  }
}
